/**
 * Colour tokens for the analytics dashboard.
 *
 * These are literal hexes rather than Chakra theme tokens because the
 * dashboard was built against a design that predates the portal's theme.
 * Migrating them is a separate job — they are centralised here so it stays a
 * one-file change.
 */
export const palette = {
  text: "#1A202C",
  muted: "#858D9D",
  label: "#54596C",
  border: "#EBECEF",
  surface: "white",
  soft: "#F3F5FC",
  purple: "#3B338D",
  purpleDark: "#4012AB",
  green: "#3CB18B",
  yellow: "#FBBF24",
  red: "#EC5858",
  blue: "#3182CE",
  cyan: "#10A6B5",
  shadow:
    "rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 1px 2px 0px",
};
